// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"ae0dce76","154":"1e24abc4","271":"23cd6f7f","641":"a38cc57c","747":"729544ba","863":"13fcc6b3"}[chunkId] + ".chunk.js";
};